"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomElementMode = exports.CustomElementType = void 0;
var CustomElementType;
(function (CustomElementType) {
    CustomElementType["ATTACHMENT"] = "attachment";
    CustomElementType["TEXT"] = "text";
    CustomElementType["SELECT"] = "select";
    CustomElementType["SELECT_NUMBER"] = "select_number";
    CustomElementType["CURRENCY"] = "currency";
    CustomElementType["CHECKBOX"] = "checkbox";
    CustomElementType["NUMBER"] = "number";
})(CustomElementType = exports.CustomElementType || (exports.CustomElementType = {}));
var CustomElementMode;
(function (CustomElementMode) {
    CustomElementMode["INTERNAL"] = "internal";
    CustomElementMode["EXTERNAL"] = "external";
    CustomElementMode["BOTH"] = "both";
})(CustomElementMode = exports.CustomElementMode || (exports.CustomElementMode = {}));
